import React from "react";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import AboutBreadcrumb from "../components/AboutPage/AboutBreadcrumb/AboutBreadcrumb";

import Main from "../components/Main/Main"

const ServicePage = () => {
  return (
    <>
      {/* Header */}
      <Header />

      {/* Hero / Breadcrumb */}
      <AboutBreadcrumb label="Our Services" />


<Main />


      {/* Footer */}
            <Footer />
          </>
        );
      };

      export default ServicePage;